export const version = '3.0.0 pt 3: December 13, 2023: Quarks'

/**
 * PSEUDO DO NOT CHANGE THIS LINE
 * PSEUDO DO NOT CHANGE THIS LINE
 * PSEUDO DO NOT CHANGE THIS LINE
 * PSEUDO DO NOT CHANGE THIS LINE
 * PSEUDO DO NOT CHANGE THIS LINE
 * PSEUDO DO NOT CHANGE THIS LINE
 */
export const testing: boolean = false
export const lastUpdated = new Date(Date.UTC(2024, 0, 17, 2, 18, 35))
/**
 * CHANGE THIS ONE INSTEAD
 */
export const prod: boolean = true
